<div>     
  <div class="m-t-15 m-b-10">
    <span>{{ question.name }}</span>
  </div>
</div>
<div *ngIf="question.answers" class="card-body p-0">
  <form [formGroup]="checkboxForm">
    <div *ngFor="let answerControl of getAnswerrControls(); let i=index;">
      <input [name]="question.answers[i]" 
      [type]="(getIsCheckbox()) ? 'checkbox' : 'radio'" 
      [formControl]="answerControl" 
      [checked]="answerControl.value"
      (click)="selectAnswer(question.answers[i])"
      class="with-gap"
      [id]="getUniqueInputName(question.answers[i].id)"/>
      <label class="answer-text" [for]="getUniqueInputName(question.answers[i].id)">{{ question.answers[i].name }}</label>
    </div>
  </form>
</div>